import { render, staticRenderFns } from "./HoldingPage.vue?vue&type=template&id=b6cf48ac&scoped=true"
import script from "./HoldingPage.vue?vue&type=script&lang=js"
export * from "./HoldingPage.vue?vue&type=script&lang=js"
import style0 from "./HoldingPage.vue?vue&type=style&index=0&id=b6cf48ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6cf48ac",
  null
  
)

export default component.exports